import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import xss from 'xss';

const SPECIAL_CHARACTERS = [
  '~',
  '!',
  '^',
  '*',
  '(',
  ')',
  '-',
  '+',
  '{',
  '[',
  '}',
  ']',
  '\\',
  '"',
  '?',
];

export default {
  truncate(source: string, size: number): string {
    return source.length > size ? source.slice(0, size - 4) + '...' : source; // eslint-disable-line no-magic-numbers
  },
  escapeHtmlToTextNode(str: string): string {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;');
  },
  // eslint-disable-next-line complexity
  isNilOrEmpty(value: string): boolean {
    return (
      isNil(value) ||
      ((isObject(value) || isString(value) || isArray(value)) && isEmpty(value))
    );
  },
  getByteLength(s: string): number {
    return new Blob([s]).size;
  },
  toHTML(text: string): string {
    if (text) {
      if (!text.startsWith('<p>')) {
        const html = text.split('\n').reduce((accumulator, currentValue) => {
          return accumulator + '<p>' + currentValue + '</p>';
        }, '');
        return xss(html);
      }
    }
    return xss(text);
  },

  removeWhitespace(value: string): string {
    return value.replace(/\s/g, '');
  },

  isValidIssueKey(key: string): boolean {
    const regexPattern = /^[a-zA-Z\d]+-\d+$/;
    return regexPattern.test(key);
  },

  // Adding wilcard to text improves JQL search results
  // Given issue with summary with number and '-' character: Example 'word-17'
  // Searching for text "word" will not return this issue without wildcard
  // Wildcard tells jira that after this word ther can be any character
  addWildCardToText(text: string): string {
    if (text === '') {
      return text;
    }
    return `${text.trim()}*`;
  },

  getStringWithoutSpecialCharacters(text: string): string {
    const specialCharactersRegex = new RegExp(
      `[${SPECIAL_CHARACTERS.map((char) => `\\${char}`).join('')}]`,
      'g'
    );
    return text.replace(specialCharactersRegex, '');
  },

  capitalize: <T extends string>(text: T): Capitalize<Lowercase<T>> => {
    return (text.charAt(0).toUpperCase() +
      text.slice(1).toLowerCase()) as Capitalize<Lowercase<T>>;
  },
};
